import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "項目名稱",
    isNumber: true,
  },
];

export const HealthCheckupItemAnalysis = {
  label: "健檢項目分析",
  key: "HealthCheckupItemAnalysis",
  path: "HealthCenterHealthCheckup/HealthCheckupItemAnalysis",
  api: "TCS_V_HCCS04",
  render: (options) => (
    <Diagram.HealthCenterHealthCheckup.HealthCheckupItemAnalysis {...options} />
  ),
  isColSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "是否異常",
      field: "是否異常",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
